import { Box, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { useQuery } from "react-query";
import fetcher from "../../src/dataProvider";
import { STRAPI_API_URL } from "../../src/constant/appConstants";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const useStyles = makeStyles((theme) => ({
  howit__workSection: {
    position: "relative",
    "@media (max-width:767px)": {
      marginBottom: "30px",
    },
    "& h2": {
      fontFamily: "Inter",
      fontSize: "200px",
      color: "#0C091B",
      background:
        "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
      "-webkit-background-clip": "text",
      "-webkit-background-clip": "text",
      "background-clip": "text",
      width: "100%",
      textAlign: "center",
      textTransform: "uppercase",
      "-webkit-text-stroke": " 4px transparent",
      "@media (max-width:1024px)": {
        display: "none",
      },
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "& h3": {
      color: "#fff",
      fontSize: "35px",
      fontWeight: "bold",
      position: "absolute",
      top: "43px",
      left: "0",
      right: "0",
      "@media (max-width:1024px)": {
        position: "inherit",
        top: "auto",
        marginBottom: "30px",
      },
      "@media (max-width:767px)": {
        position: "inherit",
        top: "auto",
      },
    },
  },
  fan__Accordion: {
    background: "linear-gradient(90deg, #ECE9E6 0%, #FFFFFF 100%)",
    borderRadius: "10px",
    fontWeight: "600",
    fontSize: "24px",
    color: "#0C091B",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all .4s ease-in-out",
    "@media (max-width:1024px)": {
      padding: "15px 15px !important",
      fontSize: "18px",
    },
    "@media (max-width:767px)": {
      padding: "10px 15px !important",
      fontSize: "14px",
      borderRadius: "3px !Important",
    },

    "& .MuiSvgIcon-fontSizeLarge": {
      curser: "pointer",
      "@media (max-width:1024px)": {
        fontSize: "28px",
      },
      "@media (max-width:767px)": {
        fontSize: "30px",
      },
    },
  },
  Accordion__open: {
    backgroundImage:
      "linear-gradient(to right, #ff9bbd, #ffabb6, #ffbdb7, #ffcebe, #ffdfcc)",
    padding: "60px",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    width: "1080px",
    margin: "auto",
    fontSize: "19px",
    position: "relative",
    left: "0",
    right: "0",
    animation: "slidein 0.4s",
    animationFillMode: "forwards",
    "@media (max-width:1024px)": {
      width: "90%",
      padding: "30px",
      fontSize: "16px",
    },
    "@media (max-width:767px)": {
      width: "90%",
      padding: "20px",
      fontSize: "14px",
    },
    "& ol": {
      padding: "0 16px",
    },
  },
  fan__FaqSectionDetails: {
    position: "relative",
    cursor: "pointer",
  },
  FaqALl: {
    bottom: "89px",
    zIndex: "1",
    position: "relative",
    "@media (max-width:767px)": {
      bottom: "0px",
    },
  },
  fan__FaqSection: {
    marginTop: "-50px",
    "@media (max-width:480px)": {
      padding: "30px 0",
      marginTop: "0",
    },
  },
}));

function Faq(props) {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const handlefaqCard = (panel) => {
    let panelDt = isExpanded === panel ? 0 : panel;
    setIsExpanded(panelDt);
  };

  const [homeFaq, setHomeFaq] = useState("");
  const { data: homeFaqData } = useQuery(
    `${STRAPI_API_URL}/faq-questions`,
    () =>
      fetcher.get(`${STRAPI_API_URL}/faq-questions`, {
        params: {
          [`filters[faq_category][category_title][$eq]`]: props.slug
            ? `faq-song-${props.slug}`
            : "Home FAQ",
          populate: "*",
          sort: ["sequence"],
        },
      })
  );

  useEffect(() => {
    if (homeFaqData) {
      setHomeFaq(homeFaqData);
    }
  }, [homeFaqData]);

  const FAQComponent = (faqs) => {
    return (
      <>
        <div id="Faqs" className={classes.howit__workSection}>
          <Typography variant="h2">FAQ&#39;s</Typography>
          <Typography variant="h3" textAlign={"center"}>
            FAQ&#39;s
          </Typography>
        </div>
        <div className={classes.FaqALl}>
          {faqs?.faqs?.data &&
            faqs?.faqs?.data?.map((item) => {
              return (
                <Grid
                  justifyContent="center"
                  direction="row"
                  alignItems="center"
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  key={item?.id}
                  id={item?.id}
                  className={
                    isExpanded === item?.id + 1 ? "accordion show" : "accordion"
                  }
                >
                  <Grid
                    item
                    md={12}
                    sx={{ width: "100%" }}
                    onClick={() => handlefaqCard(item?.id + 1)}
                  >
                    <Card className={classes.fan__Accordion} sx={{ p: 4 }}>
                      {item?.attributes?.question}
                      <AddCircleOutlinedIcon
                        fontSize="large"
                        className={
                          isExpanded === item?.id + 1 ? "plus rotate" : "plua"
                        }
                      />
                    </Card>
                    <div
                      className={classes.Accordion__open}
                      style={{
                        display: isExpanded === item?.id + 1 ? "block" : "none",
                        transition: "all 1s ease-in",
                      }}
                    >
                      <Typography variant="p">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                          {item?.attributes?.answer}
                        </ReactMarkdown>
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              );
            })}
        </div>
      </>
    );
  };

  return (
    <>
      <section className={classes.fan__FaqSection}>
        <Container maxWidth="lg">
          <Box
            className={classes.fan__FaqSectionDetails}
            sx={{ width: "100%" }}
          >
            {homeFaq?.data?.length > 0 && <FAQComponent faqs={homeFaq} />}
          </Box>
        </Container>
      </section>
    </>
  );
}

export default Faq;
